import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_media-manager-77/artifacts/dthvxc89_JLA%20Consultants%20LLC%20Logo.png";

const Logo = ({ className = "" }) => {
  return (
    <img
      src={LOGO_URL}
      alt="JLa Consultants LLC"
      className={`h-12 w-auto object-contain select-none ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
